import React, { useContext } from 'react';
import { RegularPriceRow } from './regular';
import { usePriceRowContext } from '../../price-row-context';
import { useDispatch } from 'react-redux';
import {
  productPriceClick,
  productClickOutBounce,
} from 'src/areas/product/actions/product';
import { IPriceRow } from '../types';
import { ProductPriceClickStatus } from 'src/areas/product/actions/types';
import {
  trackOurChoiceExperimentClickOut,
  trackProductSizeVariantClickout,
} from '../../../tracking';
import { usePriceListContext } from '../../price-list-context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';

export const PriceRow: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceRow>
>> = props => {
  const { item, index, className, isInPrimaryList } = props;
  const { productId, isOurChoice, position } = usePriceRowContext();
  const { variantValues } = usePriceListContext();
  const { selectedSizeVariants } = useContext(PriceListFilterContext);
  const rowKey = `${item.id}-${index}`;
  const dispatch = useDispatch();

  return (
    <RegularPriceRow
      key={rowKey}
      onClickOutBounce={() => {
        dispatch(productClickOutBounce(productId, item.id));
      }}
      onPriceClick={(
        featured: boolean,
        status: ProductPriceClickStatus,
        isAlternative: boolean
      ) => {
        // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
        // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
        setTimeout(() => {
          dispatch(
            productPriceClick(productId, item, featured, status, isAlternative)
          );
        });

        if (item) {
          trackOurChoiceExperimentClickOut({
            price: item,
            isOurChoice: Boolean(isOurChoice),
            offerListPosition: index,
            position,
          });

          if (variantValues?.sizes?.length) {
            trackProductSizeVariantClickout({
              isVariantFiltered: Boolean(selectedSizeVariants?.length),
              isPrimaryList: Boolean(isInPrimaryList),
            });
          }
        }
      }}
      className={className}
    />
  );
};
